import { render } from "./whatsapp.vue?vue&type=template&id=7888a816&scoped=true&lang=html"
import script from "./whatsapp.vue?vue&type=script&lang=js"
export * from "./whatsapp.vue?vue&type=script&lang=js"

import "./whatsapp.vue?vue&type=style&index=0&id=7888a816&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7888a816"]])

export default __exports__